import { deepFreeze } from "@/helpers/immutabilityUtilities";

const columnsMap: Map< string, string > = new Map< string, string >();
columnsMap.set( 'symbol', 'Symbol' );
columnsMap.set( 'sector', 'Sector' );
columnsMap.set( 'opened_stock_price', 'Stock (Entry $)' );
columnsMap.set( 'opened_options_price', 'Options (Entry $)' );
columnsMap.set( 'last_close', 'Last Close' );
columnsMap.set( 'stance', 'Stance' );
columnsMap.set( 'bpi_status', 'BPI Status' );
columnsMap.set( 'sector_rs', 'Sector RS' );
columnsMap.set( 'peer_rs', 'Peer RS' );
columnsMap.set( 'mkt_rs', 'MKT RS' );
columnsMap.set( 'current_stock_gains', 'Current Stock Gains' );
columnsMap.set( 'current_options_gains', 'Current Options Gains' );
columnsMap.set( 'initiated', 'Initiated' );
columnsMap.set( 'last_updated', 'Last Updated' );
columnsMap.set( 'last_check_point', 'Most Recent Checkpoint' );
columnsMap.set( 'price_target', 'Price Target' );
columnsMap.set( 'stop_loss', 'Stop Loss' );
columnsMap.set( 'm_e_gain', 'M/E Gain' );
columnsMap.set( 'max_gain', 'Max Gain' );
columnsMap.set( 'option_expiration_month', 'Option Expiration Month' );
columnsMap.set( 'option_strike', 'Option Strike' );
columnsMap.set( 'actions', 'Actions' );
columnsMap.set( 'closed', 'Exited' );
columnsMap.set( 'closed_stock_price', 'Stock (Exit $)' );
columnsMap.set( 'closed_options_price', 'Options (Exit $)' );
columnsMap.set( 'buy_under', 'Buy Under' );
columnsMap.set( 'stock_gains', 'Stock P&L' );
columnsMap.set( 'options_gains', 'Options P&L' );
columnsMap.set( 'note', 'Weighting' );

const modelPortfolioAvailableColumns: Readonly< Map< string, string > >  = deepFreeze( columnsMap );
export { modelPortfolioAvailableColumns };
